import { useEffect, useRef, useState } from "react";
import { makeCaptureSessionId } from "../eieConstants";

export function usePersistentCaptureMetadata() {
  const [captureSessionId, setCaptureSessionId] = useState(() => {
    if (typeof localStorage === "undefined") return makeCaptureSessionId();
    return localStorage.getItem("eie:captureSessionId") || makeCaptureSessionId();
  });
  const [captureLabel, setCaptureLabel] = useState(() => {
    if (typeof localStorage === "undefined") return "";
    return localStorage.getItem("eie:captureLabel") || "";
  });
  const [captureTestType, setCaptureTestType] = useState(() => {
    if (typeof localStorage === "undefined") return "custom";
    return localStorage.getItem("eie:captureTestType") || "custom";
  });
  const [captureDeviceTag, setCaptureDeviceTag] = useState(() => {
    if (typeof localStorage === "undefined") return "";
    return localStorage.getItem("eie:captureDeviceTag") || "";
  });
  const [captureLightingTag, setCaptureLightingTag] = useState(() => {
    if (typeof localStorage === "undefined") return "";
    return localStorage.getItem("eie:captureLightingTag") || "";
  });
  const [captureProject, setCaptureProject] = useState(() => {
    if (typeof localStorage === "undefined") return "AlphaHubHealthcareSupport";
    return localStorage.getItem("eie:captureProject") || "AlphaHubHealthcareSupport";
  });
  const [captureOperator, setCaptureOperator] = useState(() => {
    if (typeof localStorage === "undefined") return "";
    return localStorage.getItem("eie:captureOperator") || "";
  });

  const captureSessionIdRef = useRef(captureSessionId);
  const captureLabelRef = useRef(captureLabel);
  const captureTestTypeRef = useRef(captureTestType);
  const captureDeviceTagRef = useRef(captureDeviceTag);
  const captureLightingTagRef = useRef(captureLightingTag);
  const captureProjectRef = useRef(captureProject);
  const captureOperatorRef = useRef(captureOperator);

  useEffect(() => {
    captureSessionIdRef.current = captureSessionId;
  }, [captureSessionId]);

  useEffect(() => {
    captureLabelRef.current = captureLabel;
  }, [captureLabel]);

  useEffect(() => {
    captureTestTypeRef.current = captureTestType;
  }, [captureTestType]);

  useEffect(() => {
    captureDeviceTagRef.current = captureDeviceTag;
  }, [captureDeviceTag]);

  useEffect(() => {
    captureLightingTagRef.current = captureLightingTag;
  }, [captureLightingTag]);

  useEffect(() => {
    captureProjectRef.current = captureProject;
  }, [captureProject]);

  useEffect(() => {
    captureOperatorRef.current = captureOperator;
  }, [captureOperator]);

  useEffect(() => {
    if (typeof localStorage === "undefined") return;
    localStorage.setItem("eie:captureSessionId", captureSessionId);
    localStorage.setItem("eie:captureLabel", captureLabel);
    localStorage.setItem("eie:captureTestType", captureTestType);
    localStorage.setItem("eie:captureDeviceTag", captureDeviceTag);
    localStorage.setItem("eie:captureLightingTag", captureLightingTag);
    localStorage.setItem("eie:captureProject", captureProject);
    localStorage.setItem("eie:captureOperator", captureOperator);
  }, [
    captureSessionId,
    captureLabel,
    captureTestType,
    captureDeviceTag,
    captureLightingTag,
    captureProject,
    captureOperator,
  ]);

  return {
    captureSessionId,
    setCaptureSessionId,
    captureLabel,
    setCaptureLabel,
    captureTestType,
    setCaptureTestType,
    captureDeviceTag,
    setCaptureDeviceTag,
    captureLightingTag,
    setCaptureLightingTag,
    captureProject,
    setCaptureProject,
    captureOperator,
    setCaptureOperator,
    captureSessionIdRef,
    captureLabelRef,
    captureTestTypeRef,
    captureDeviceTagRef,
    captureLightingTagRef,
    captureProjectRef,
    captureOperatorRef,
  };
}
